import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad } from 'utils';
import { Loader } from 'components';
import { NoItemsYet } from '../../noItem';
import { noteViewNotYet } from './constants';
import { LocalDateRow } from '../../table';
import { noteActions } from 'store';

const ACTION_TYPE = 'GET_NOTE_BY_ID';

export const NoteHistoryModal = ({ noteId }) => {
    const noteById = useSelector((state) => state.note?.noteById) || [];
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (noteId) {
            dispatch(noteActions.getNoteById(noteId));
        }
    }, []);

    return (
        <div style={{ width: 550, height: '70vh', maxHeight: '70vh', minHeight: '70vh' }}>
            {loader?.length ? (
                <Loader height="70vh" />
            ) : (
                <div>
                    <p className="modal-header-title" style={{ marginBottom: 20 }}>
                        {`Viewed history (${noteById?.viewedBy?.length || 0})`}
                    </p>
                    {noteById?.viewedBy?.length ? (
                        <div className="note-viewed-wrapper">
                            {noteById?.viewedBy?.map((i, j) => (
                                <div key={j} className="note-viewed-box">
                                    <div className="note-viewed-avatar-box">
                                        {i?.firstName && i?.lastName ?
                                            `${i.firstName.slice(0, 1)}${i.lastName.slice(0, 1)}`
                                            :
                                            i?.fullName?.split(' ').filter(Boolean).slice(0, 2).map((name) => name.charAt(0)).join('')
                                        }
                                    </div>
                                    <div>
                                        <p className="note-viewed-date">
                                            <LocalDateRow date={i?.viewedAt} />
                                        </p>
                                        <p className="note-viewer">{i?.fullName}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div>
                            <NoItemsYet
                                containerStyles={{ position: 'relative' }}
                                text={noteViewNotYet.title}
                                subTitle={noteViewNotYet.subTitle}
                                image={noteViewNotYet.image}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
